import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnDestroy, ViewChild, inject } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import flatpickr from 'flatpickr';
import type { Instance } from 'flatpickr/dist/types/instance';
import type { Options } from 'flatpickr/dist/types/options';

@Component({
  selector: 'app-date-block',
  imports: [ReactiveFormsModule, TranslateModule],
  templateUrl: './date-block.html',
  styleUrl: './date-block.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class DateBlock implements AfterViewInit, OnDestroy {
  private readonly controlContainer = inject(ControlContainer);

  @Input({ required: true }) controlId = '';
  @Input({ required: true }) controlName = '';
  @Input() defaultHour = 0;
  @Input() defaultMinute = 0;
  @Input() fullWidth = false;
  @Input() invalid = false;
  @Input({ required: true }) labelKey = '';

  @ViewChild('dateInput') private dateInput?: ElementRef<HTMLInputElement>;

  private picker: Instance | null = null;

  @HostBinding('class.date-block-full')
  get hostFullWidth(): boolean {
    return this.fullWidth;
  }

  ngAfterViewInit(): void {
    const input = this.dateInput?.nativeElement;
    if (!input) {
      return;
    }

    const options: Options = {
      allowInput: true,
      allowInvalidPreload: true,
      dateFormat: 'Y-m-d H:i',
      defaultHour: this.defaultHour,
      defaultMinute: this.defaultMinute,
      disableMobile: true,
      enableTime: true,
      minuteIncrement: 1,
      onChange: (_selectedDates: Date[], dateString: string) => {
        this.controlContainer.control?.get(this.controlName)?.setValue(dateString);
      },
      time_24hr: true,
    };

    this.picker = flatpickr(input, options);
  }

  ngOnDestroy(): void {
    this.picker?.destroy();
    this.picker = null;
  }
}
